import {Container} from "./Container"

export const UserProfileStyles = {
    Container: Container
}